import Image from 'next/image';

import { Button, Container } from 'darrius';

import { Toast } from '../../../../../../components';

import { useLeadExpressCheckout } from '../../../../../../hooks/useLeadExpressCheckout';

import { imgPrefix } from '../../../../../../utils';

import styles from './ServiceExpressCard.module.scss';

import { type TServiceExpressPrice } from '../../../../../../modules/serviceExpress';

interface IServiceExpressCardProps {
  uuid: string;
  id: number;
  price: TServiceExpressPrice | null;
}

const FEATURES = [
  {
    icon: '/images/ab-test/lead-express/pros.svg',
    alt: 'Ícone com 3 cartões representando os profissionais da plataforma',
    text: 'Veja agora profissionais disponíveis para você, sem esperar até 48 horas',
  },
  {
    icon: '/images/ab-test/lead-express/chat.svg',
    alt: 'Ícone de mensagem',
    text: 'Escolha com quem falar e entre em contato na hora',
  },
];

export function ServiceExpressCard({
  uuid,
  id,
  price,
}: IServiceExpressCardProps) {
  const { isPayingForServiceExpress, payForServiceExpress } =
    useLeadExpressCheckout({
      uuid,
      id,
      trackingSuffix: '_order_details',
    });

  return (
    <Container className={styles.container}>
      <section className={styles.card}>
        <header className={styles.header}>
          <Image
            src={imgPrefix('/images/ab-test/lead-express/clock.svg')}
            alt=""
            width={48}
            height={48}
            className={styles['header-icon']}
          />

          <div>
            <p className={styles.eyebrow}>Atendimento Express</p>

            <h3 className={styles.title}>
              Receba contato imediato de profissionais
            </h3>
          </div>
        </header>

        <ul className={styles.features}>
          {FEATURES.map((feature) => (
            <li key={feature.text} className={styles.feature}>
              <Image
                src={imgPrefix(feature.icon)}
                alt={feature.alt}
                width={24}
                height={24}
                className={styles['feature-icon']}
              />

              <p className={styles['feature-text']}>{feature.text}</p>
            </li>
          ))}
        </ul>

        {price && (
          <div className={styles.offer}>
            <span className={styles.badge}>
              <Image
                src={imgPrefix('/images/ab-test/lead-express/fire.svg')}
                alt=""
                width={12}
                height={12}
              />
              Oferta limitada
            </span>

            <p className={styles.prices}>
              <span className={styles['price-from']}>{price.from}</span>
              <strong className={styles['price-to']}>{price.to}</strong>
            </p>
          </div>
        )}

        <Button.Root
          disabled={isPayingForServiceExpress}
          isLoading={isPayingForServiceExpress}
          onClick={payForServiceExpress}
          fullWidth
          size="small"
        >
          Ver meus profissionais agora
        </Button.Root>
      </section>

      <Toast />
    </Container>
  );
}
